export interface CreateUpdatePortalThemeRequest {
  theme: string;
  primaryLogo: string;
  secondaryLogo: string;
  favIcon?: string;
}
